const toKebabCase = (value) => value
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .toLowerCase();

const cssVarName = (token) => `--color-${toKebabCase(token)}`;

const applyTheme = (themeConfig = {}, rootElement = null) => {
    if (typeof document === "undefined") {
        return;
    }

    const colors = themeConfig.colors || {};

    const root = rootElement || document.documentElement;
    Object.entries(colors).forEach(([token, entry]) => {
        if (entry) {
            root.style.setProperty(cssVarName(token), entry);
        }
    });
};
export default applyTheme;
